export const FIRST_NAMES = ['Youssef','Salma','Aymen','Karim','Nour','Mehdi','Rania','Bilel','Sonia','Wassim','Ines','Anis','Sami','Lina','Hatem','Imen']
export const LAST_NAMES  = ['Karoui','Mejri','Ben Ali','Hammami','Trabelsi','Gharbi','Jelassi','Khelifi','Bouazizi','Sassi','Chouchane','Mahjoub']
export const CITIES      = ['Tunis','Sfax','Sousse','Nabeul','Bizerte','Monastir','Mahdia','Gabès','Kairouan','Djerba']
export const STREETS     = ['Av. Habib Bourguiba','Rue de Carthage','Av. de la Liberté','Rue d\'Alger','Av. Mohamed V','Rue Ibn Khaldoun','Lac 2','Centre Urbain Nord','Rue de Marseille','Av. Jugurtha']
export const COMPANIES   = ['Olive & Co.','Karaz Express','Médina Boutique','Atlas Tech','Phoenicia Foods','Sahara Crafts','TunisHome','Bella Vita']

export interface SeedPerson {
  first: string
  last: string
  name: string
  city: string
  street: string
  company: string
}

export function seed(n: number): SeedPerson[] {
  return Array.from({ length: n }).map((_, i) => {
    const first = FIRST_NAMES[i % FIRST_NAMES.length]
    const last  = LAST_NAMES[(i * 3) % LAST_NAMES.length]
    return { first, last, name: first + ' ' + last, city: CITIES[i % CITIES.length], street: STREETS[i % STREETS.length], company: COMPANIES[i % COMPANIES.length] }
  })
}

const ORDER_STATUSES = ['delivered','in_transit','picked_up','pending','cancelled'] as const

export interface MockOrder {
  id: string
  from: string
  to: string
  customer: string
  shipper: string
  courier: string
  status: string
  cod: number
  weight: string
  created: string
  eta: string
  payout: string
}

export function makeOrders(n: number, opts: { idStart?: number; courier?: string; status?: string } = {}): MockOrder[] {
  const ppl = seed(n)
  return ppl.map((p, i) => {
    const baseId = opts.idStart ?? 48000
    return {
      id: 'DD-' + (baseId + i),
      from: STREETS[i % STREETS.length] + ', Tunis',
      to:   p.street + ', ' + p.city,
      customer: p.name,
      shipper:  COMPANIES[i % COMPANIES.length],
      courier:  opts.courier ?? FIRST_NAMES[(i * 2) % FIRST_NAMES.length] + ' ' + LAST_NAMES[(i * 5) % LAST_NAMES.length],
      status:   opts.status ?? ORDER_STATUSES[i % ORDER_STATUSES.length],
      cod:      Math.round((30 + (i * 13.7) % 180) * 1000) / 1000,
      weight:   ((i * 1.3) % 9 + 0.5).toFixed(1) + ' kg',
      created:  `${10 + (i % 14)} Mai`,
      eta:      `${10 + (i * 7) % 50} min`,
      payout:   ((i * 0.7) % 9 + 3).toFixed(2),
    }
  })
}
